import React from 'react';
import { FinishNewsletterPopup } from '@husky-x/cc-finish-newsletter-popup';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { FinishNewsletterImageForm } from '@phx-husky/cc-finish-newsletter-image-form';
import { FinishProductDifferences } from '@phx-husky/cc-finish-product-differences';
import { FinishProductsCards } from '@phx-husky/cc-finish-products-cards';

import {
  FinishNewsletterPopupMock,
  FinishProductCardsMock,
  FinishProductCardsMockBG,
  FinishProductDifferencesMock,
  FinishProductDifferencesMockBG,
} from './custom-components-mocks';
import CustomPanAnimation from './src/@husky-x/gatsby-theme-husky/components/CustomPanAnimation';
import {
  panConfigBG,
  panConfigDefault,
} from './src/@husky-x/gatsby-theme-husky/components/CustomPanAnimation/config';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'FinishProductDifferences',
        component: () => <FinishProductDifferences {...FinishProductDifferencesMock} />,
      },
      {
        key: 'FinishProductDifferencesBG',
        component: () => <FinishProductDifferences {...FinishProductDifferencesMockBG} />,
      },
      {
        key: 'FinishProductCards',
        // @ts-expect-error - cardsStyle in ProdCards is coded as set of specified strings - mocks provides those strings, but guardtypes them as 'string'
        component: () => <FinishProductsCards {...FinishProductCardsMock} />,
      },
      {
        key: 'FinishProductCardsBG',
        // @ts-expect-error - cardsStyle in ProdCards is coded as set of specified strings - mocks provides those strings, but guardtypes them as 'string'
        component: () => <FinishProductsCards {...FinishProductCardsMockBG} />,
      },
      {
        key: 'FinishNewsletterPopup',
        component: () => <FinishNewsletterPopup {...FinishNewsletterPopupMock} />,
      },
      {
        key: 'custom_finish_newsletter_image_form',
        component: FinishNewsletterImageForm,
      },
      {
        key: 'FinishCouponPanAnimation',
        component: CustomPanAnimation,
      },
      {
        key: 'FinishCouponPanAnimation',
        component: (props) => <CustomPanAnimation {...props} config={panConfigDefault} />,
      },
      {
        key: 'FinishCouponPanAnimationBG',
        component: (props) => <CustomPanAnimation {...props} config={panConfigBG} />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
